// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ThankYouMessage.css */

.thank-you-container {
  text-align: center;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 20px;
  
  background-color: #f8f8f8;
}

.thank-you-header {
 color: #536b9f;    
  font-size: 28px;
}

.thank-you-text {
  color: #555;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/ThankU.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;CACC,cAAc;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* ThankYouMessage.css */\r\n\r\n.thank-you-container {\r\n  text-align: center;\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  margin: 20px;\r\n  \r\n  background-color: #f8f8f8;\r\n}\r\n\r\n.thank-you-header {\r\n color: #536b9f;    \r\n  font-size: 28px;\r\n}\r\n\r\n.thank-you-text {\r\n  color: #555;\r\n  font-size: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
